import { useState } from "react"
import KitAttribute from "./KitAttribute"
import { formatPrice } from "utils";
import { kitValuesKey } from '../../CreateAsset/CreateAsset-Helper'
import { getOnlyNumbers } from "client/utils/RequisitionUtil";
import { CONSTANTS } from "client/utils/constants";

const kitValuesValidationKeys = ['kitDescription1', 'kitDescription2', 'unitPrice', 'quantity']

  

const KitAttributeContainer = (props:any) => {

    const {
        setKitAttributeValues,
        kitAttributeValues,
        getTotalKitPrice,
        validateAddedKitValues,
        setCatalogItemErrors,
        catalogItemValues
    } = props;


    const [quantity, setQuantity] = useState(1);
    const [kitError, setKitError] = useState<any>({})
    const [state, setState] = useState<any>({
        kitDescription1: '',
        kitDescription2: '',
        unitPrice: 0,
        quantity: 1
    })


    const handleOnChange = (event:any) => {
        const name = event.target.name
        const value = event.target.value
        if(name === 'quantity' && Number(value)){
            setQuantity(Number(value))
            setState({
                ...state,
               [name]: Number(value)
            })
        } else if(name === 'quantity'){
            setState({
                ...state,
               [name]: 1
            })
            setQuantity(1)
        } else {
            validateKitValues(value, name)
            setState({
                ...state,
               [name]: value
            })
        }
    }   

    const handleClickAddNewRow = () => {

        let validateValues = kitValuesValidationKeys.map((name: any) => {
            return validateKitValues(state[name], name)
        })

        let totalPrice = parseFloat(getTotalKitPrice()) + (getOnlyNumbers(state?.unitPrice) * Number(state?.quantity))
        let isKitPricevalid = true
        let errorText = ''
        let catalogItemPrice = 0
        if(catalogItemValues?.vehicleType?.orderRequestType === CONSTANTS.PRODUCTION_VEHICLE || catalogItemValues?.vehicleType?.orderRequestType === CONSTANTS.MANAGEMENT_VEHICLE){
            catalogItemPrice = parseFloat(getOnlyNumbers(catalogItemValues?.actualPrice))
            errorText = 'The Total Kit Price does not match the Actual Price'
        }
        else {
            catalogItemPrice = parseFloat(getOnlyNumbers(catalogItemValues?.price));
            errorText = 'The Total Kit Price does not match the Price'
        }
        if (catalogItemPrice < totalPrice) {
            isKitPricevalid = false
            setCatalogItemErrors((prev: any) => ({ ...prev, kitTotalError: errorText }))
          } else {
            setCatalogItemErrors((prev: any) => ({ ...prev, kitTotalError: '' }))
          }
          let isValidToSubmit = validateValues.every((value: boolean) => value === true) && isKitPricevalid

        if(isValidToSubmit){
            const lastKey = kitAttributeValues?.length ? Math.max(...kitAttributeValues.map((kit: any) => kit.kitNumber)) : 0
            const newKitAttribute = {...state, kitIndex: lastKey + 1, kitNumber: lastKey + 1}
            setKitAttributeValues([...kitAttributeValues, newKitAttribute])
            setState({
                kitDescription1: '',
                kitDescription2: '',
                unitPrice: 0,
                quantity: 1
            })
            setQuantity(1)
        }
    }
    
    const handleClickRemoveRow = (kitNumber:any) => {
        let kitAttributesTemp =JSON.parse(JSON.stringify(kitAttributeValues)).filter((kit: any) => kit.kitNumber !== kitNumber)
        setKitAttributeValues(kitAttributesTemp) 
    }

    const incrementQuantity = (event:any) => {
        setQuantity(quantity + 1)
        setState((prev: any) => ({...prev, quantity: quantity + 1}))
    }

    const decrementQuantity = (event: any) => {
        setQuantity(quantity - 1)
        setState((prev: any) => ({...prev, quantity: quantity - 1}))
    }

    const onChangeQuantity = (e:any) => {
        if (e.target.value == '' || parseInt(e.target.value) == 0) {
            setQuantity(1);
        }
        else {
            setQuantity(parseInt(e.target.value));
        }
    }

    const validateKitValues = (value: any, name: any) => {
        let isValid = true
        if(!value || (name == "unitPrice" && value == '0.00')){
            isValid = false
            setKitError((prev: any) => ({ ...prev, [name]: `Please provide ${kitValuesKey.get(name)}`}))
        } else if(value.length > 100 && (name === 'kitDescription1' || name === 'kitDescription2')){
            isValid = false
            setKitError((prev: any) => ({ ...prev, [name]: `Please provide ${kitValuesKey.get(name)} in less than 100 characters`}))
        } else if(name === 'unitPrice' && Number(value) > 9999999999){
            isValid = false
            setKitError((prev: any) => ({ ...prev, [name]: `Please provide valid ${kitValuesKey.get(name)}`}))
        } else {
            setKitError((prev: any) => ({ ...prev, [name]: ''}))
        }
        return isValid
    }

    const handleChangeKitAttribute = (e: any, kitNumber: number) => {
        const name = e.target.name
        const value = e.target.value
        let kitAttributesTemp = kitAttributeValues.length ? JSON.parse(JSON.stringify(kitAttributeValues)) : []
        kitAttributesTemp.forEach((kit: any) => {
            if(kit.kitNumber === kitNumber){
                let kitError = validateAddedKitValues(name === 'quantity' ?  Number(value || 1) : value, name, (kit?.kitErrors ?? {}))?.errors
                kit[name] = name === 'quantity' ?  Number(value || "1") : value
                kit.kitErrors = kitError
            }
        });
        setCatalogItemErrors((prev: any) => ({...prev, kitTotalError: '', kitError: ''}))
        setKitAttributeValues(kitAttributesTemp) 
    }

    const decrementAddedQuantity = (kitNumber: number) => {
        let kitAttributesTemp = kitAttributeValues.length ? JSON.parse(JSON.stringify(kitAttributeValues)) : []
        kitAttributesTemp.forEach((kit: any) => {
            if(kit.kitNumber === kitNumber){
                kit.quantity -= 1
                kit.kitErrors = {}
            }
        });
        setCatalogItemErrors((prev: any) => ({...prev, kitTotalError: '', kitError: ''}))
        setKitAttributeValues(kitAttributesTemp) 
    }

    const increamentAddedQuantity = (kitNumber: number) => {
        let kitAttributesTemp = kitAttributeValues.length ? JSON.parse(JSON.stringify(kitAttributeValues)) : []
        kitAttributesTemp.forEach((kit: any) => {
            if(kit.kitNumber === kitNumber){
                kit.quantity += 1
                kit.kitErrors = {}
            }
        });
        setCatalogItemErrors((prev: any) => ({...prev, kitTotalError: '', kitError: ''}))
        setKitAttributeValues(kitAttributesTemp) 
    }

    const priceFormat = (e: any, name: string, kitNumber?: number) => {
        if (e.target.value == 0) {
            return
        }
        validateKitValues(e.target.value, name)
        if(kitNumber){
            let kitAttributesTemp = kitAttributeValues.length ? JSON.parse(JSON.stringify(kitAttributeValues)) : []
            kitAttributesTemp.forEach((kit: any) => {
                if (kit.kitNumber === kitNumber) {
                    kit[name] = formatPrice(e.target.value, 2)
                }
            });
        setKitAttributeValues(kitAttributesTemp) 
        }else {
            setState((prev: any) => ({ ...prev, [name]: formatPrice(e.target.value, 2) }));
        }
    };

    return(
        <KitAttribute
            handleOnChange={handleOnChange}
            handleClickAddNewRow={handleClickAddNewRow}
            state={state}
            handleClickRemoveRow={handleClickRemoveRow}    
            quantity={quantity}    
            incrementQuantity={incrementQuantity} 
            decrementQuantity={decrementQuantity}
            onChangeQuantity={onChangeQuantity}
            kitAttributeValues={kitAttributeValues}
            handleChangeKitAttribute={handleChangeKitAttribute}
            increamentAddedQuantity={increamentAddedQuantity}
            decrementAddedQuantity={decrementAddedQuantity}
            kitError={kitError}
            priceFormat={priceFormat}
            getTotalKitPrice={getTotalKitPrice}
        />
    )
}

export default KitAttributeContainer